<template>
  <div class="wrapper">
    <el-card class="box-card" v-for="(card,index) in update.col.data">
      <div slot="header" class="clearfix">
        <div>{{questionName[update.col.question]+(index+1)}}</div>
        <div style="float: right">
          <el-button type="text" @click="addReward()">{{$t('other.bt.add')}}</el-button>
          <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('other.bt.delete')}}</el-button>
        </div>
      </div>
      <div class="text item">
        <el-form-item :label="$t('other.question.question')" :required="true">
          <el-input v-model="card.question" type="textarea" autosize></el-input>
        </el-form-item>
        <div v-for="(option,optionIndex) in card.options">
          <el-form-item :label="$t('other.question.options')+(optionIndex+1)" :required="true">
            <el-button type="text" @click="optionAdd(card.options)">{{$t('other.question.addOption')}}</el-button>
            <el-button v-if="card.options.length > 1" type="text" @click="optionDelete(card.options,optionIndex)">{{$t('other.question.deleteOption')}}</el-button>
            <el-input v-model="option.question" type="textarea" autosize></el-input>
          </el-form-item>
        </div>
        <el-form-item v-if="update.col.question == 'decide'" :label="$t('other.question.answer')" :required="true">
          <el-radio v-for="(value,key) in answerList" v-model="card.answer" :label="Number(key)">{{value}}</el-radio>
        </el-form-item>
        <el-form-item v-if="update.col.question != 'decide'"  :label="$t('other.question.answer')" :required="true">
          <el-input v-model="card.answer" type="textarea" autosize></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.question.parsing')" :required="true">
          <el-input v-model="card.parsing" type="textarea" autosize></el-input>
        </el-form-item>

      </div>
    </el-card>
  </div>
</template>

<script>
    export default {
        name: 'question',
        props:["update"],
        data(){
            return {
                answerList:{0:"错",1:"对"},
                questionName:{
                    "decide":window.$t('other.question.decide'),
                    "radio":window.$t('other.question.radio'),
                    "checkbox":window.$t('other.question.checkbox')
                }
            }
        },
        methods: {
            addReward(){
                if (this.update.col.question == 'decide') {
                    this.update.col.data.push({});
                }
                else {
                    this.update.col.data.push({options:[{}]});
                }
            },
            delReward(index){
                this.update.col.data.splice(index, 1);
            },
            optionAdd(options){
                options.push({});
            },
            optionDelete(options,index){
                options.splice(index, 1);
            },
        },
    }
</script>
